module.exports = __webpack_public_path__ + "static/media/item_23_4_comp.034356cd.png";